import { ArrayOps, getValue } from '../lift';
/**
 * Updates an item at the specified index.
 */
export function updateAt(index, updater) {
    var result = this.value().slice();
    if (result.length > index && index > -1)
        result[index] = getValue(updater(result[index]));
    return new ArrayOps(result);
}
ArrayOps.prototype.updateAt = updateAt;
